import { ApiResponse, Service } from '@roc/feature-app-core';
import { AIDocType } from '@roc/feature-documents';
import { DocReviewBaseService } from './docReviewBaseService';

const url = {
  GET_AI_DOC_DATA: `/api/v1/doc-review/aiDocReview/getDocReviewData`,
  GET_REVIEW_TASK_DATA: `/api/v1/doc-review/aiDocReview/getDocReviewTaskData`,
  GET_IDENTITY_REVIEW_TASK_DATA: `/api/v1/doc-review/identityDocumentReview/getDocReviewTaskData`,
  SAVE_DOC_DATA: `/api/v1/doc-review/aiDocReview/saveData`,
  SAVE_DOC_CHECKLIST_DATA: `/api/v1/doc-review/aiDocReview/saveDocumentCheckList`,
  SEND_REVISION: `/api/v1/doc-review/aiDocReview/sendRevision`,
  CHANGE_STATUS: `/api/v1/doc-review/aiDocReview/changeStatus`,
  GET_AUTOMATION_STATUS: `/api/v1/doc-review/aiDocReview/getAutomationStatus`,
  GET_REVISION_COMMENT: `/api/v1/doc-review/aiDocReview/getRevisionComment`,
  GET_DOC_CHECKLIST: `/api/v1/doc-review/aiDocReview/getDocumentCheckList`,
  GET_REVISION_TEXT: '/api/v1/doc-review/insurance/getInsuranceRevisionText',
  SAVE_DOC_REVIEW_TASK_DATA: `/api/v1/doc-review/aiDocReview/saveDocReviewTaskData`,
  GET_TASK: `/api/v1/taskV2/findByTaskId`,
  GET_BORROWER_ENTITY_EDIT_FORM: `/api/v1/doc-review/aiDocReview/getBorrowerEntityEditForm`,
  GET_BORROWER_IDENTITY_DATA: '/nportal/rest/priv/borrowerIdentityCheck/getIdentityData',
  GET_POST_QC_DOCUMENT: `/api/v1/doc-review/aiDocReview/postClosing/document`,
};

export class DocReviewInternalService extends DocReviewBaseService {
  getDocChecklist(id: number, docType: string): Promise<ApiResponse> {
    return this.get(url.GET_DOC_CHECKLIST, { id, docType });
  }

  saveDocChecklist(list: any[]): Promise<ApiResponse> {
    return this.post(url.SAVE_DOC_CHECKLIST_DATA, list);
  }

  sendRevisionDoc(id: number, docType: string): Promise<ApiResponse> {
    return this.get(url.SEND_REVISION, {
      id,
      docType,
      includeAttachment: true,
    });
  }

  getBorrowerEntityEditForm(taskId: number): Promise<ApiResponse> {
    return this.get(url.GET_BORROWER_ENTITY_EDIT_FORM, { taskId });
  }

  getDocReviewData(id: number, type: AIDocType, disableGlobalLoading = false) {
    return this.get(url.GET_AI_DOC_DATA, { id, type }, { disableGlobalLoading });
  }


  saveDocReviewData(id: number, type: string, data: any): Promise<ApiResponse> {
    return this.post(`${url.SAVE_DOC_DATA}?id=${id}&docType=${type}`, data);
  }

  changeStatus(
    id: number,
    docType: string,
    status: string,
    data: string
  ): Promise<ApiResponse> {
    return this.post(
      `${url.CHANGE_STATUS}?id=${id}&docType=${docType}&status=${status}`,
      data
    );
  }

  getAutomationStatus(id: number, docType: string): Promise<ApiResponse> {
    return this.get(`${url.GET_AUTOMATION_STATUS}?id=${id}&docType=${docType}`);
  }

  getRevisionComment(docType: string, key: string): Promise<ApiResponse> {
    return this.get(url.GET_REVISION_COMMENT, { docType, key });
  }

  getReviewTaskData(taskId: number): Promise<ApiResponse> {
    return this.get(url.GET_REVIEW_TASK_DATA, { taskId });
  }

  getIdentityReviewTaskData(taskId: number): Promise<ApiResponse> {
    return this.get(url.GET_IDENTITY_REVIEW_TASK_DATA, { taskId });
  }

  getBorrowerIdentityData(borrowerId: number, idType: string): Promise<ApiResponse> {
    return this.get(url.GET_BORROWER_IDENTITY_DATA, { borrowerId, idType });
  }

  saveDocReviewTaskData(taskId: number, data: any): Promise<ApiResponse> {
    return this.post(`${url.SAVE_DOC_REVIEW_TASK_DATA}?taskId=${taskId}`, data);
  }

  getTaskById(taskId: number): Promise<ApiResponse> {
    return this.get(url.GET_TASK, { taskId });
  }

  getPostQcDocument(loanId: number, sectionName: string, documentId?: number): Promise<ApiResponse> {
    return this.get(
      url.GET_POST_QC_DOCUMENT,
      { loanId, sectionName, documentId },
      { responseType: 'arraybuffer', disableGlobalLoading: true }
    );
  }
}
